import React from 'react';
import { Tooltip as MuiTooltip, withStyles } from '@material-ui/core';

const COLOR = 'rgba(252, 252, 252, 0.8)';
const Tooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(21, 20, 20, 0.7)',
    color: '#ffffff',
    boxShadow: theme.shadows[1],
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '18px',
    borderRadius: '4px'
  }
}))((props) => <MuiTooltip arrow placement='bottom' {...props} data-testid='tooltip' />);

export const PlanDetails = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#4E4B66',
    color: COLOR,
    boxShadow: theme.shadows[1]
  }
}))((props) => (
  <MuiTooltip
    arrow
    placement='bottom-start'
    enterDelay={200}
    leaveDelay={500}
    {...props}
    data-testid='plan-details-tooltip'
  />
));

export const GameCenterTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#4E4B66',
    color: COLOR,
    boxShadow: theme.shadows[1],
    borderRadius: '16px'
  },
  arrow: {
    borderTop: '30px solid transparent',
    borderBottom: '30px solid transparent',
    borderRight: '25px solid #4e4b66'
  }
}))((props) => <MuiTooltip arrow placement='right' {...props} data-testid='game-center-tooltip' />);

export const BillingTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#4E4B66',
    color: COLOR,
    boxShadow: theme.shadows[1],
    borderRadius: '16px',
    fontSize: '14px',
    padding: '12px'
  },
  arrow: {
    color: '#4E4B66'
  }
}))((props) => <MuiTooltip arrow placement='top' {...props} data-testid='billing-tooltip' />);

export const VirtualCoffeeTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#333333',
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '18px',
    borderRadius: '4px'
  },
  arrow: {
    color: '#ffffff'
  }
}))((props) => (
  <MuiTooltip arrow placement='top' {...props} data-testid='virtual-coffee-tooltip' />
));

export const PlanCardTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#4E4B66',
    color: '#FFFFFF',
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '18px',
    borderRadius: '4px'
  },
  arrow: {
    color: '#4E4B66',
    marginLeft: '-8px'
  }
}))((props) => <MuiTooltip arrow placement='top' {...props} data-testid='Plan-Card-tooltip' />);

export default Tooltip;
